
export default {
    name: 'Theme1MainCard',
}
